import React from 'react';
import {Button, Col, Form, FormGroup, Modal, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBank, faCheck} from "@fortawesome/free-solid-svg-icons";
import ApiService from "../../api/ApiService";
import {toast} from "react-toastify";

const WithdrawModal = ({visible ,canWithdrawAmount, onClose}) => {
    const api = new ApiService();
    const [isMobile, setIsMobile] = React.useState(false);
    const [withdrawInfo, setWithdrawInfo] = React.useState(null);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState(1); // 渠道，0,银行卡，1 支付宝，2 微信
    // 添加表单字段的状态
    const [amount, setAmount] = React.useState(0);
    const [account, setAccount] = React.useState('');
    const [mobile, setMobile] = React.useState('');
    const alipayIcon = '/images/vip/vip_pay_method_alipay.svg'

    React.useEffect(() => {
        if (!visible) {
            return;
        }
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };

        handleResize(); // 初始化时调用
        window.addEventListener('resize', handleResize);
        setWithdrawInfo(null);
        setAccount(null);
        setMobile(null);
        getSignAccountInfo();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [visible]);
    const getSignAccountInfo = async () => {
        var result = await api.getUserSignInfo();
        if (result?.code !== 200) {
            toast.error(result?.msg)
        } else {
            if (result?.data?.withdraw) {
                setWithdrawInfo(result?.data?.withdraw);
                // 使用 useEffect 监听 withdrawInfo 变化后再调用 setSelectedPayment
            }
        }
    };
    const submitInfo = async (event) => {

        event.preventDefault();
        if (!amount){
            return toast.error('请填写提现金额');
        }
        if (amount > canWithdrawAmount) {
            return toast.error('提现金额不能大于可提现余额');
        }
        if (!account) {
            return toast.error(selectedPaymentMethod === 1 ? '请先补充支付宝账号信息' : '请先补充银行卡账号信息');
        }
        const withdraw = await api.submitUserWithdrawInfo((amount*100),selectedPaymentMethod,account, mobile);

        if (withdraw?.code !== 200) {
            toast.error(withdraw?.msg);
        }
        if (withdraw?.code === 200) {
            toast.success('提现申请提交成功')
            onClose(true,false);
        }

    };
    React.useEffect(() => {
        // 当 withdrawInfo 或 selectedPaymentMethod 变化时更新表单字段
        if (withdrawInfo && withdrawInfo.length > 0) {
            const selectedWithdrawInfo = withdrawInfo.find(item => item.channel === selectedPaymentMethod);
            if (selectedWithdrawInfo) {
                setAccount(selectedWithdrawInfo.account || '');
                setMobile(selectedWithdrawInfo.mobile || '');
            } else {
                setAccount('');
                setMobile('');
            }
        } else {
            setAccount('');
            setMobile('');
        }

    }, [withdrawInfo, selectedPaymentMethod]);
    return (

        <Modal show={visible} centered onHide={onClose}
               style={{'--bs-modal-margin': '2rem', '--bs-modal-width': '700px'}}>
            <Modal.Header closeButton style={{
                background: 'linear-gradient(90deg,#02C8E3 30%, #963BC8 120%)',
                borderBottomColor: 'transparent'
            }}>
                <span style={{color: '#060606', fontSize: '22px'}}>提现</span>
            </Modal.Header>
            <Modal.Body style={{background: '#1E2129'}}>
                <h5 style={{color: '#FFFFFF'}}>用户信息<span style={{color: '#9a9a9a',fontSize: '14px',marginLeft: '20px'}}>可提现余额：{canWithdrawAmount}元</span></h5>
                <Form onSubmit={submitInfo} style={{color: '#FFFFFF', fontSize: '14px'}}>

                    <FormGroup as={Row} className="mb-3">
                        <Form.Label column xs={4} sm={3} style={{paddingRight: '0'}}>提现金额<span style={{fontSize: '12px'}}>(元)</span></Form.Label>
                        <Col xs={8} sm={9}>
                            <Form.Control 
                                name={'amount'}
                                placeholder='请输入需要提现金额'
                                type={'number'}
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                            />
                        </Col>
                    </FormGroup>
                    <Row className="paymentMethod">
                        <Col md={6}>
                            <Button
                                type={"button"}
                                className={`w-100 mb-2 payment-method-button ${selectedPaymentMethod === 1 ? 'selected-payment-method-button' : ''}`}
                                onClick={() => setSelectedPaymentMethod(1)}>
                               <span style={{display: "inline-flex", alignItems: "center"}}>
                                     <img src={alipayIcon} alt="支付宝" className="payment-method-icon"/>
                                支付宝
                               </span>

                                <div className="payment-method-check">
                                    {selectedPaymentMethod === 1 &&
                                        <FontAwesomeIcon icon={faCheck} color={'#02C8E3'}/>}
                                </div>
                            </Button>
                        </Col>
                        <Col md={6}>
                            <Button
                                type={"button"}
                                className={`w-100 mb-2 payment-method-button ${selectedPaymentMethod === 0 ? 'selected-payment-method-button' : ''}`}
                                onClick={() => setSelectedPaymentMethod(0)}>
                                  <span style={{display: "inline-flex", alignItems: "center"}}><FontAwesomeIcon
                                      icon={faBank} className={'payment-method-icon'}/>
                                     银行卡
                                  </span>
                                <div className="payment-method-check">
                                    {selectedPaymentMethod === 0 &&
                                        <FontAwesomeIcon icon={faCheck} color={'#02C8E3'}/>}
                                </div>
                            </Button>
                        </Col>
                    </Row>
                    <div className={"mb-2"} style={{ display: 'flex', justifyContent: 'end'}}><span onClick={() => {onClose (false,true)}} style={{color: '#02C8E3',fontSize: '14px',textDecoration: 'underline',padding: '0px 10px'}}>补充账号信息</span></div>
                    <FormGroup as={Row} className="mb-3">
                        <Form.Label column xs={4}
                                    sm={3} style={{paddingRight: '0'}}>{selectedPaymentMethod === 1 ? '支付宝账号' : '银行卡账号'}</Form.Label>
                        <Col xs={8} sm={9}>
                            <Form.Control
                                readOnly={true}
                                name={'account'}
                                value={account}
                                onChange={(e) => setAccount(e.target.value)}
                            />
                        </Col>
                    </FormGroup>

                    <Row style={{height: '50px'}}>
                        <Col xs={4} style={{textAlign: 'center'}}>
                            <Button variant="primary" type={'button'} onClick={() => onClose(false,false)} style={{
                                width: '100%',
                                height: '100%',
                                border: '1px solid #02C8E3',
                                background: "transparent",
                                color: '#02C8E3',
                            }}>
                                取消
                            </Button>
                        </Col>
                        <Col xs={8} style={{textAlign: 'center'}}>
                            <Button variant="primary" type={'submit'} style={{
                                width: '100%',
                                height: '100%',
                                background: 'linear-gradient(135deg,#02C8E3,#4B1E64 150%)',
                                border: 'none',
                                color: '#060606'
                            }}>
                                提交
                            </Button>
                        </Col>

                    </Row>
                </Form>
            </Modal.Body>
            {/* 全局CSS样式 */}
            <style>{`
                .form-control::placeholder {
                    color: #7D7D7D !important;
                }
            `}</style>
        </Modal>

    );
};

export default WithdrawModal;